module.exports = __webpack_public_path__ + "img/b771f7b.png";